
/* CW speed: cap HLS rendition to the viewport so phones don't pull 1080p (≈halves mobile video bytes). */
function cwApplyLevelCap(hls) {
  if (!hls || typeof Hls === 'undefined') return;
  var capH = (window.innerWidth <= 767) ? 720 : 1080;
  hls.on(Hls.Events.MANIFEST_PARSED, function () {
    try {
      var levels = hls.levels || [];
      var cap = -1;
      for (var i = 0; i < levels.length; i++) {
        var h = levels[i].height || 0;
        if (h && h <= capH && (cap === -1 || h > levels[cap].height)) cap = i;
      }
      hls.autoLevelCapping = cap; // -1 = hls.js default (no cap) when nothing matched
    } catch (e) {}
  });
}

function ___initCustomVideoPlayerWithHLS_videoSection(sectionId) {
  const section = document.querySelector(`[data-section-id="${sectionId}"]`);
  if (!section) return;

  const videoWrapperAll = section.querySelectorAll('.banner_video_wrapper');
  videoWrapperAll.forEach((videoWrapper) => {
    let video = videoWrapper?.querySelector('video');
    if (!video || video.dataset.initialized === 'true') return;
    video.dataset.initialized = 'true';

    const isMobile = window.innerWidth <= 767;
    const src = isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
    const poster = isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
    const autoplay = (isMobile ? video.dataset.autoplayM : video.dataset.autoplay) === 'true';
    const showMuteBtn = (isMobile ? video.dataset.muteM : video.dataset.mute) === 'true';
    const showFullscreenBtn = (isMobile ? video.dataset.fullscreenM : video.dataset.fullscreen) === 'true';
    const posterEnabled = section.dataset.posterEnabled === 'true';

    const playBtn = videoWrapper.querySelector('.glb_play');
    const muteBtn = videoWrapper.querySelector('.glb_mute');
    const fullscreenBtn = videoWrapper.querySelector('.glb_fullscreen');

    const newVideo = video.cloneNode(true);
    video.replaceWith(newVideo);
    video = newVideo;

    video.poster = poster;
    video.muted = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    let hls;
    const videoPosterImage = videoWrapper.querySelector('.video_poster');

    if( video.dataset.showPoster == 'true' )
    {

      const autoplayCounterWrapper = videoWrapper.querySelector('.autoplay-counter-wrapper');
      const counterSpan = videoWrapper.querySelector('.autoplay-counter .counter-number');
      const previewProgress = videoWrapper.querySelector('.next-preview-progress');
      const previewImageWrapper = videoWrapper.querySelector('.next-slide-preview');

  
    
      let countdownInterval;
      let countdownStartTime;
      let countdownPausedTime = 0;
      let countdownDuration = 5; // seconds
      let countdownStarted = false;
      let countdownPaused = false;
      
      function startCountdown() {
        countdownStartTime = Date.now() - countdownPausedTime;
        countdownStarted = true;
        countdownPaused = false;
      
        autoplayCounterWrapper.style.display = 'flex';
        previewProgress.style.transition = 'none';
        previewProgress.style.width = `${(countdownPausedTime / 1000 / countdownDuration) * 100}%`;
      
        requestAnimationFrame(() => {
          const remainingDuration = countdownDuration - countdownPausedTime / 1000;
          previewProgress.style.transition = `width ${remainingDuration}s linear`;
          previewProgress.style.width = '100%';
        });
      
        updateCounter();
        countdownInterval = setInterval(updateCounter, 250);
      }
      
      function stopCountdown() {
        clearInterval(countdownInterval);
        autoplayCounterWrapper.style.display = 'none';
        previewProgress.style.transition = 'none';
        previewProgress.style.width = '0%';
        countdownStarted = false;
        countdownPaused = false;
        countdownPausedTime = 0;
      }
      function showReplayCountdown(seconds) {
        let replayCount = seconds;
        autoplayCounterWrapper.style.display = 'flex';
        counterSpan.textContent = replayCount;
      
        const replayInterval = setInterval(() => {
          replayCount -= 1;
          counterSpan.textContent = replayCount;
      
          if (replayCount <= 0) {
            clearInterval(replayInterval);
            autoplayCounterWrapper.style.display = 'none';
      
            loadVideoSource();
            video.play().catch((err) => console.warn("Replay error:", err));
            countdownStarted = false;
            countdownPausedTime = 0;
          }
        }, 1000);
      }
      function pauseCountdown() {
        if (countdownStarted && !countdownPaused) {
          clearInterval(countdownInterval);
          countdownPausedTime = Date.now() - countdownStartTime;
          previewProgress.style.transition = 'none';
      
          const currentWidth = getComputedStyle(previewProgress).width;
          previewProgress.style.width = currentWidth;
      
          countdownPaused = true;
        }
      }
      
      function updateCounter() {
        const elapsed = (Date.now() - countdownStartTime) / 1000;
        let remaining = Math.floor(countdownDuration - elapsed);
        if (remaining < 0) remaining = 0;
      
        counterSpan.textContent = remaining;
      
        if (remaining <= 0) {
          clearInterval(countdownInterval);
      
          setTimeout(() => {
            autoplayCounterWrapper.style.display = 'none';
            video.pause();
            unloadVideoSource();
            loadVideoSource();
            showReplayCountdown(5);
      
            
          }, 300);
        }
      }
      
      
      // Trigger countdown based on video time
      video.addEventListener('timeupdate', () => {
        const remainingTime = video.duration - video.currentTime;
      
        if (remainingTime <= countdownDuration && !countdownStarted && !video.paused) {
          startCountdown();
        }
      
        // Stop if user skips back
        if (remainingTime > countdownDuration && countdownStarted) {
          stopCountdown();
        }
      });
      
      // Pause/resume countdown
      video.addEventListener('pause', () => {
        videoPosterImage.style.display = "block";
        pauseCountdown();
      });
      
      video.addEventListener('play', () => {
        const remainingTime = video.duration - video.currentTime;
        videoPosterImage.style.display = "none";
        if (remainingTime <= countdownDuration && countdownPaused) {
          startCountdown(); // resumes from paused time
        }
      });
    }


    
    

    function loadVideoSource() {
      if (src?.endsWith('.m3u8')) {
        window.cwEnsureHls().then(function () {
        if (!(window.Hls && Hls.isSupported()) && video.canPlayType("application/vnd.apple.mpegurl")) {
          video.src = src;
          video.preload = "auto";
          video.load();

        }
        else if (window.Hls && Hls.isSupported()) {
          if (video.hlsInstance) video.hlsInstance.destroy();

          hls = new Hls({
            autoStartLoad: true,
            maxBufferLength: 3,
            maxMaxBufferLength: 5,
            capLevelToPlayerSize: true,
          });
          cwApplyLevelCap(hls);

          hls.loadSource(src);
          hls.attachMedia(video);
          video.hlsInstance = hls;
          video.preload = "auto";
        }
        });
      } else {
        video.src = src;
        video.preload = "auto";
        video.load();
      }

      if (autoplay) {
        playBtn?.classList.remove('playing');
        videoPosterImage.style.display = "none";
        playBtn.style.display = "none";
        video.autoplay = true;

        video.addEventListener('loadeddata', () => {
          video.play().catch(err => console.warn('Autoplay failed:', err));
        }, { once: true });
      } else {
        playBtn?.classList.remove('playing');
        videoPosterImage.style.display = "block";
        playBtn.style.display = "block";
        video.autoplay = false;
        video.pause();
      }
    }

    function unloadVideoSource() {
      if (hls) {
        hls.destroy();
        hls = null;
      }
      video.pause();
      video.removeAttribute('src');
      video.load();
      playBtn?.classList.remove('playing');
    }

    // Initial load check
    const loadIfInView = () => {
      const rect = videoWrapper.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        loadVideoSource();
      }
    };
    loadIfInView();

    // Intersection observer — load only when the section is actually in view
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        loadVideoSource();
      } else {
        unloadVideoSource(); // CW fix: free the decoder off-screen (was video.pause()); loadVideoSource re-attaches on return
      }
    }, { threshold: [0] });

    observer.observe(videoWrapper);

    // Play/Pause
    if (playBtn && !playBtn.dataset.bound) {
      playBtn.dataset.bound = 'true';
      playBtn.addEventListener('click', () => {
        videoPosterImage.style.display = "none";
        if (video.paused) {
          offsoundAllVideos('trigger');
          video.play();
          video.muted = false;
          if (muteBtn) {
            muteBtn.classList.remove('muted');
          }
        } else {
          video.pause();
          if (muteBtn) {
            muteBtn.classList.add('muted');
          }
        }
      });
      video.addEventListener('play', () => {
        
        playBtn.classList.add('playing');
        playBtn.classList.remove('paused');
      });
      video.addEventListener('pause', () => {
        videoPosterImage.style.display = "block";
        playBtn.classList.add('paused');
        playBtn.classList.remove('playing');
      });
    }

    // Mute
    if (muteBtn && showMuteBtn) {
      muteBtn.style.display = 'block';
      muteBtn.addEventListener('click', () => {
        video.muted = !video.muted;
        muteBtn.classList.toggle('muted', video.muted);
      });
    }

    // Fullscreen
    if (fullscreenBtn && showFullscreenBtn) {
      fullscreenBtn.style.display = 'block';
      fullscreenBtn.addEventListener('click', () => {
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
        } else if (video.webkitRequestFullscreen) {
          video.webkitRequestFullscreen();
        }
      });
    }

  });
}

function initCustomVideoPlayerWithHLS_videoSection(sectionId) {
  const section = document.querySelector(`[data-section-id="${sectionId}"]`);
  if (!section) return;

  const videoWrapperAll = section.querySelectorAll('.banner_video_wrapper');
  videoWrapperAll.forEach((videoWrapper) => {
    let video = videoWrapper?.querySelector('video');
    if (!video || video.dataset.initialized === 'true') return;
    video.dataset.initialized = 'true';

    const isMobile = window.innerWidth <= 767;
    const src = isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
    const poster = isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
    const autoplay = (isMobile ? video.dataset.autoplayM : video.dataset.autoplay) === 'true';
    const showMuteBtn = (isMobile ? video.dataset.muteM : video.dataset.mute) === 'true';
    const showFullscreenBtn = (isMobile ? video.dataset.fullscreenM : video.dataset.fullscreen) === 'true';
    const posterEnabled = section.dataset.posterEnabled === 'true';

    const playBtn = videoWrapper.querySelector('.glb_play');
    const muteBtn = videoWrapper.querySelector('.glb_mute');
    const fullscreenBtn = videoWrapper.querySelector('.glb_fullscreen');

    const newVideo = video.cloneNode(true);
    video.replaceWith(newVideo);
    video = newVideo;

    // FIX 1: only set poster when it actually exists (prevents GET /undefined)
    if (poster && poster !== 'undefined') {
      video.poster = poster;
    }

    video.muted = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    let hls;
    const videoPosterImage = videoWrapper.querySelector('.video_poster');

    if( video.dataset.showPoster == 'true' )
    {

      const autoplayCounterWrapper = videoWrapper.querySelector('.autoplay-counter-wrapper');
      const counterSpan = videoWrapper.querySelector('.autoplay-counter .counter-number');
      const previewProgress = videoWrapper.querySelector('.next-preview-progress');
      const previewImageWrapper = videoWrapper.querySelector('.next-slide-preview');

      let countdownInterval;
      let countdownStartTime;
      let countdownPausedTime = 0;
      let countdownDuration = 5; // seconds
      let countdownStarted = false;
      let countdownPaused = false;

      function startCountdown() {
        countdownStartTime = Date.now() - countdownPausedTime;
        countdownStarted = true;
        countdownPaused = false;

        autoplayCounterWrapper.style.display = 'flex';
        previewProgress.style.transition = 'none';
        previewProgress.style.width = `${(countdownPausedTime / 1000 / countdownDuration) * 100}%`;

        requestAnimationFrame(() => {
          const remainingDuration = countdownDuration - countdownPausedTime / 1000;
          previewProgress.style.transition = `width ${remainingDuration}s linear`;
          previewProgress.style.width = '100%';
        });

        updateCounter();
        countdownInterval = setInterval(updateCounter, 250);
      }

      function stopCountdown() {
        clearInterval(countdownInterval);
        autoplayCounterWrapper.style.display = 'none';
        previewProgress.style.transition = 'none';
        previewProgress.style.width = '0%';
        countdownStarted = false;
        countdownPaused = false;
        countdownPausedTime = 0;
      }
      function showReplayCountdown(seconds) {
        let replayCount = seconds;
        autoplayCounterWrapper.style.display = 'flex';
        counterSpan.textContent = replayCount;

        const replayInterval = setInterval(() => {
          replayCount -= 1;
          counterSpan.textContent = replayCount;

          if (replayCount <= 0) {
            clearInterval(replayInterval);
            autoplayCounterWrapper.style.display = 'none';

            loadVideoSource();
            video.play().catch((err) => console.warn("Replay error:", err));
            countdownStarted = false;
            countdownPausedTime = 0;
          }
        }, 1000);
      }
      function pauseCountdown() {
        if (countdownStarted && !countdownPaused) {
          clearInterval(countdownInterval);
          countdownPausedTime = Date.now() - countdownStartTime;
          previewProgress.style.transition = 'none';

          const currentWidth = getComputedStyle(previewProgress).width;
          previewProgress.style.width = currentWidth;

          countdownPaused = true;
        }
      }

      function updateCounter() {
        const elapsed = (Date.now() - countdownStartTime) / 1000;
        let remaining = Math.floor(countdownDuration - elapsed);
        if (remaining < 0) remaining = 0;

        counterSpan.textContent = remaining;

        if (remaining <= 0) {
          clearInterval(countdownInterval);

          setTimeout(() => {
            autoplayCounterWrapper.style.display = 'none';
            video.pause();
            unloadVideoSource();
            loadVideoSource();
            showReplayCountdown(5);
          }, 300);
        }
      }

      // Trigger countdown based on video time
      video.addEventListener('timeupdate', () => {
        const remainingTime = video.duration - video.currentTime;

        if (remainingTime <= countdownDuration && !countdownStarted && !video.paused) {
          startCountdown();
        }

        // Stop if user skips back
        if (remainingTime > countdownDuration && countdownStarted) {
          stopCountdown();
        }
      });

      // Pause/resume countdown
      video.addEventListener('pause', () => {
        videoPosterImage.style.display = "block";
        pauseCountdown();
      });

      video.addEventListener('play', () => {
        const remainingTime = video.duration - video.currentTime;
        videoPosterImage.style.display = "none";
        if (remainingTime <= countdownDuration && countdownPaused) {
          startCountdown(); // resumes from paused time
        }
      });
    }

    function loadVideoSource(force) {
      // FIX 2: bail out if there is no source for this device (prevents GET /undefined)
      if (!src || src === 'undefined') {
        return;
      }

      // v33: the original attach body, unchanged, callable behind the settle gate / on user intent.
      const cwAttach = () => {
      if (src.endsWith('.m3u8')) {
        window.cwEnsureHls().then(function () {
        if (!(window.Hls && Hls.isSupported()) && video.canPlayType("application/vnd.apple.mpegurl")) {
          video.src = src;
          video.preload = "auto";
          video.load();
        }
        else if (window.Hls && Hls.isSupported()) {
          if (video.hlsInstance) video.hlsInstance.destroy();

          hls = new Hls({
            autoStartLoad: true,
            maxBufferLength: 3,
            maxMaxBufferLength: 5,
            capLevelToPlayerSize: true,
          });
          cwApplyLevelCap(hls);

          hls.loadSource(src);
          hls.attachMedia(video);
          video.hlsInstance = hls;
          video.preload = "auto";
        }
        });
      } else {
        video.src = src;
        video.preload = "auto";
        video.load();
      }

      if (autoplay) {
        playBtn?.classList.remove('playing');
        videoPosterImage.style.display = "none";
        playBtn.style.display = "none";
        video.autoplay = true;

        video.addEventListener('loadeddata', () => {
          video.play().catch(err => console.warn('Autoplay failed:', err));
        }, { once: true });
      } else if (!video.__cwUserStarted) {
        /* v34: idle-state UI only — a USER-started attach (first play click, __cwUserStarted set in the
           click handler before loadVideoSource(true)) must NOT re-show the poster over the starting video
           (that was the "sound but no picture" bug: click hid the poster, this block re-showed it, and
           nothing hid it again because the hide-on-play listener only binds when data-show-poster="true"). */
        playBtn?.classList.remove('playing');
        videoPosterImage.style.display = "block";
        playBtn.style.display = "block";
        video.autoplay = false;
        video.pause();
      }
      };

      /* v33 attach-on-intent (first play-button click): attach now, play as soon as data arrives. */
      if (force) {
        video.addEventListener('loadeddata', () => {
          video.play().catch((err) => {
            /* v34: the deferred play can outlive the gesture token (iOS) — retry muted rather than dying
               silently; the mute button (flagged muted) is the user's unmute affordance. */
            if (err && err.name === 'NotAllowedError' && !video.muted) {
              video.muted = true;
              if (muteBtn) muteBtn.classList.add('muted');
              video.play().catch(() => {});
            }
          });
        }, { once: true });
        cwAttach();
        return;
      }

      /* v33: autoplay:false + never user-started → keep the exact idle UI (poster + play button visible;
         the play icon is CSS display:none until this reveals it) but DON'T attach the source — that only
         buffered segments for a video nobody asked to watch. The click handler attaches (force=true). */
      if (!autoplay && !video.__cwUserStarted) {
        playBtn?.classList.remove('playing');
        videoPosterImage.style.display = "block";
        playBtn.style.display = "block";
        video.autoplay = false;
        video.pause();
        return;
      }

      /* Post-user-start re-entries (IO return after off-screen unload, the countdown replay at the end of
         the show-poster loop) keep the ORIGINAL behavior exactly — attach without forcing playback. */
      if (video.__cwUserStarted) { cwAttach(); return; }

      /* v33 settle gate: autoplay videos keep their motion but the attach waits for cwVideoGate
         (first interaction / `load`+2s / 8s failsafe) so segments never contend with the LCP fetch. */
      if (video.__cwGatePending) return;                 // one queued attach per video
      video.__cwGatePending = true;
      window.cwVideoGate().then(() => {
        video.__cwGatePending = false;
        const r = videoWrapper.getBoundingClientRect();
        if (r.bottom <= 0 || r.top >= window.innerHeight) return;  // left view while gated; IO re-calls
        cwAttach();
      });
    }

    function unloadVideoSource() {
      if (hls) {
        hls.destroy();
        hls = null;
      }
      video.pause();
      video.removeAttribute('src');
      video.load();
      playBtn?.classList.remove('playing');
      playBtn?.classList.add('paused');
      /* v38: restore the poster HERE, deterministically — hls.destroy() empties the element WITHOUT
         firing 'pause' (media-reset semantics), so the 'pause'-listener restore never runs on the
         off-screen release. Without this a played-then-released video returns as a transparent (gray)
         box: re-attached, paused, poster still hidden (the iPhone "gray video" report, 2026-07-03).
         PATH A/upsell unloadVideo() already restore their posters this way. */
      if (videoPosterImage) videoPosterImage.style.display = 'block';
    }

    /* v38 belt-and-braces: 'emptied' = the source is gone (any silent reset path) ⇒ poster MUST show. */
    video.addEventListener('emptied', () => {
      if (videoPosterImage && video.paused) videoPosterImage.style.display = 'block';
    });

    // Initial load check
    const loadIfInView = () => {
      const rect = videoWrapper.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        loadVideoSource();
      }
    };
    loadIfInView();

    // Intersection observer — load only when the section is actually in view
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        loadVideoSource();
      } else {
        unloadVideoSource(); // CW fix: free the decoder off-screen (was video.pause()); loadVideoSource re-attaches on return
      }
    }, { threshold: [0] });

    observer.observe(videoWrapper);

    /* v34: hide the poster when frames actually render — UNCONDITIONALLY (the showPoster-gated listener
       above only binds when data-show-poster="true", which is why autoplay:false sections kept the poster
       over a playing video). cwWakeAndVerify restores poster + paused icon if the engine advances audio
       without decoding frames (iOS stuck-rendering) — a re-click retries. */
    video.addEventListener('playing', () => {
      if (videoPosterImage) videoPosterImage.style.display = 'none';
      if (window.cwWakeAndVerify) window.cwWakeAndVerify(video, () => {
        if (videoPosterImage) videoPosterImage.style.display = 'block';
        playBtn?.classList.add('paused');
        playBtn?.classList.remove('playing');
      });
    });

    // Play/Pause
    if (playBtn && !playBtn.dataset.bound) {
      playBtn.dataset.bound = 'true';
      playBtn.addEventListener('click', () => {
        /* v34: poster-first — the poster hides on 'playing' (frames rendering), not at click; slow attaches
           show the poster instead of a black gap. cwBankGesture banks the tap on the element so the deferred
           play() (post-cwEnsureHls) keeps its user-gesture rights on WebKit/iOS. */
        if (video.paused) {
          if (window.cwBankGesture) window.cwBankGesture(video);
          offsoundAllVideos('trigger');
          if (!video.__cwUserStarted && !video.hlsInstance && !video.getAttribute('src')) {
            video.__cwUserStarted = true;
            loadVideoSource(true);   // v33 attach-on-intent: first click attaches the source + plays on loadeddata
          } else {
            video.__cwUserStarted = true;
            video.play();
          }
          video.muted = false;
          if (muteBtn) {
            muteBtn.classList.remove('muted');
          }
        } else {
          video.pause();
          if (muteBtn) {
            muteBtn.classList.add('muted');
          }
        }
      });
      video.addEventListener('play', () => {
        playBtn.classList.add('playing');
        playBtn.classList.remove('paused');
      });
      video.addEventListener('pause', () => {
        videoPosterImage.style.display = "block";
        playBtn.classList.add('paused');
        playBtn.classList.remove('playing');
      });
    }

    // Mute
    if (muteBtn && showMuteBtn) {
      muteBtn.style.display = 'block';
      muteBtn.addEventListener('click', () => {
        video.muted = !video.muted;
        muteBtn.classList.toggle('muted', video.muted);
      });
    }

    // Fullscreen
    if (fullscreenBtn && showFullscreenBtn) {
      fullscreenBtn.style.display = 'block';
      fullscreenBtn.addEventListener('click', () => {
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
        } else if (video.webkitRequestFullscreen) {
          video.webkitRequestFullscreen();
        }
      });
    }

  });
}


function initCustomVideoPlayerWithHLS(sectionId) {
  let thresholdValue = 0.2;
  setTimeout(() => {
    thresholdValue = 0.5;
  }, 7000);

  const section = document.querySelector(`[data-section-id="${sectionId}"]`);
  if (!section) return;

  const videoWrappers = section.querySelectorAll('.banner_video_wrapper');
  const isMobile = window.innerWidth <= 767;

  videoWrappers.forEach((wrapper) => {
    const video = wrapper.querySelector('video');
    if (!video || video.dataset.initialized === 'true') return;
    video.dataset.initialized = 'true';

    const getSrc = () => isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
    const getPoster = () => isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
    const shouldAutoplay = () => (isMobile ? video.dataset.autoplayM : video.dataset.autoplay) === 'true';
    const showMute = (isMobile ? video.dataset.muteM : video.dataset.mute) === 'true';
    const showFullscreen = (isMobile ? video.dataset.fullscreenM : video.dataset.fullscreen) === 'true';

    const playBtn = wrapper.querySelector('.glb_play');
    const muteBtn = wrapper.querySelector('.glb_mute');
    const fullscreenBtn = wrapper.querySelector('.glb_fullscreen');

    let hls = null;
    let isNativeHLS = false;
    let isVideoLoaded = false;

    // // Poster layer
    // const posterUrl = getPoster();
    // const posterWrapper = document.createElement('picture');
    // posterWrapper.className = 'custom-poster-wrapper';
    // Object.assign(posterWrapper.style, {
    //   position: 'absolute',
    //   top: 0,
    //   left: 0,
    //   width: '100%',
    //   height: '100%',
    //   zIndex: 1,
    //   background: `url('${posterUrl}') center center / cover no-repeat`,
    //   pointerEvents: 'none',
    //   transition: 'opacity 0.4s ease',
    //   opacity: 1
    // });

    // wrapper.style.position = 'relative';
    // wrapper.appendChild(posterWrapper);
    // video._posterWrapper = posterWrapper;
    // Poster layer
const posterUrl = getPoster();

// Helper: set Shopify CDN image width on the URL
const sized = (url, w) => {
  try {
    const u = new URL(url, location.href);
    u.searchParams.set('width', w);
    return u.href;
  } catch (e) {
    return url; // non-URL / data URI: leave as-is
  }
};

// Reuse the server-rendered poster from hero-video.liquid if present (LCP fix);
// fall back to JS creation for sections without one.
let posterWrapper = wrapper.querySelector('img.hero-poster');
// v33: a server-rendered poster exists ONLY on the hero → it gets the FAST settle gate (motion at `load`,
// not load+2s) so the above-fold brand look starts promptly while still clearing the LCP window.
const cwIsHero = !!posterWrapper;

if (!posterWrapper && posterUrl) {
  posterWrapper = document.createElement('img');
  posterWrapper.className = 'hero-poster';
  posterWrapper.src = sized(posterUrl, 860);
  posterWrapper.srcset = [
    `${sized(posterUrl, 320)} 320w`,
    `${sized(posterUrl, 540)} 540w`,
    `${sized(posterUrl, 860)} 860w`,
    `${sized(posterUrl, 1280)} 1280w`,
  ].join(', ');
  // CW speed: size to the poster's ACTUAL display width. These JS-built posters render ~137-690px in
  // sliders/grids (never full-viewport — the hero reuses its own server poster above), so sizes='100vw'
  // was making a 181px slot pull the 1920w rendition. Measure the box; cap the ladder at 1280 (posters are
  // placeholders the video replaces). Fall back to 50vw if the box isn't laid out yet (deferred/display:none).
  const _cw = Math.round((wrapper.getBoundingClientRect && wrapper.getBoundingClientRect().width) || 0);
  posterWrapper.sizes = _cw > 0 ? _cw + 'px' : '50vw';
  // CW speed: these JS-built posters are for below-the-fold video sections — the hero reuses its own
  // server-rendered eager poster above (guard at line 693) and never reaches here. `lazy` still loads
  // any poster already in the viewport immediately, but defers the far-below-fold ones (incl. the heavy
  // topaz thumbnails + the 4 MB collection-grid poster) off the no-scroll critical path. No eager/high.
  posterWrapper.loading = 'lazy';
  posterWrapper.decoding = 'async';
  posterWrapper.alt = '';
  wrapper.appendChild(posterWrapper);
}

if (posterWrapper) {
  Object.assign(posterWrapper.style, {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1,
    objectFit: 'cover',
    pointerEvents: 'none',
    transition: 'opacity 0.4s ease',
    opacity: 1,
  });
}

wrapper.style.position = 'relative';
video._posterWrapper = posterWrapper;

    // Setup video
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('preload', 'metadata');
    video.setAttribute('muted', '');
    video.muted = true;

    function safePlay() {
      
     const playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise
          .then(() => {
            playBtn?.classList.add('playing');
            // Don't hide poster yet — wait for "playing" event
          })
          .catch((err) => {
            /* v34: the deferred play can outlive the gesture token (iOS) — retry muted rather than dying;
               the mute button (flagged muted) is the user's unmute affordance. */
            if (err && err.name === 'NotAllowedError' && !video.muted) {
              video.muted = true;
              if (muteBtn) muteBtn.classList.add('muted');
              video.play().catch(() => {
                playBtn?.classList.remove('playing');
                if (posterWrapper) posterWrapper.style.opacity = 1;
              });
              return;
            }
            playBtn?.classList.remove('playing');
            if (posterWrapper) posterWrapper.style.opacity = 1;
          });
      }
    }

    video.addEventListener('playing', () => {
      // Hide poster only when video is actually rendering
      if (posterWrapper) posterWrapper.style.opacity = 0;
      /* v34: 'playing' can fire with frame decoding stuck (iOS) — verify frames advance, nudge with a
         micro-seek, and restore the poster + paused state if rendering never starts (re-click retries). */
      if (window.cwWakeAndVerify) window.cwWakeAndVerify(video, () => {
        playBtn?.classList.remove('playing');
        if (posterWrapper) posterWrapper.style.opacity = 1;
      });
    });


    function pauseVideo() {
      video.pause();
      playBtn?.classList.remove('playing');
      if (posterWrapper) posterWrapper.style.opacity = 1;
    }

    // CW fix: fully release the decoder when the video is off-screen (prevents decoder exhaustion → random blanks).
    let __cwUnloadTimer = null;
    function unloadVideo() {
      if (hls) { try { hls.destroy(); } catch (e) {} hls = null; }
      video.hlsInstance = null;
      video.removeAttribute('src');
      video.querySelectorAll('source').forEach((s) => s.remove());
      try { video.load(); } catch (e) {}
      isVideoLoaded = false;
      video.removeAttribute('data-loaded-src');
      playBtn?.classList.remove('playing');
      if (posterWrapper) posterWrapper.style.opacity = 1;
    }

    // v33: the actual source attach, split out of loadVideo so it can run behind the settle gate.
    // `force` = user clicked play (attach-on-intent) → attach + play regardless of the autoplay setting.
    function cwAttachVideo(force) {
      const src = getSrc();
      const wantPlay = shouldAutoplay() || force;

      video.setAttribute('data-loaded-src', src);
      if (src.endsWith('.m3u8')) {
        window.cwEnsureHls().then(function () {
        isNativeHLS = !(window.Hls && Hls.isSupported()) && video.canPlayType('application/vnd.apple.mpegurl') !== '';
        if (isNativeHLS) {
          video.src = src;
          video.load();
          isVideoLoaded = true;
          video.addEventListener('loadedmetadata', () => {
            if (wantPlay) safePlay();
          }, { once: true });
        } else if (window.Hls && Hls.isSupported()) {
          hls = new Hls({ maxBufferLength: 3, maxMaxBufferLength: 5, capLevelToPlayerSize: true });
          cwApplyLevelCap(hls);
          hls.loadSource(src);
          hls.attachMedia(video);
          video.hlsInstance = hls;

          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            isVideoLoaded = true;
            if (wantPlay) safePlay();
          });
        }
        });
      } else {
        const source = document.createElement('source');
        source.src = src;
        source.type = 'video/mp4';
        video.appendChild(source);
        video.load();
        isVideoLoaded = true;
        video.addEventListener('loadedmetadata', () => {
          if (wantPlay) safePlay();
        }, { once: true });
      }

      playBtn?.classList.toggle('playing', wantPlay);
      //playBtn?.style.setProperty('display', autoplay ? 'none' : 'block');
      //if (posterWrapper) posterWrapper.style.opacity = autoplay ? 0 : 1;
    }

    function loadVideo(force) {
      const src = getSrc();
      const autoplay = shouldAutoplay();

      if (isVideoLoaded && video.getAttribute('data-loaded-src') === src) {
        if (autoplay || force) safePlay();
        return;
      }

      /* v33 attach-on-intent: an autoplay:false video's rendered look IS the poster + play icon — attaching
         the source on mere visibility only buffered segments nobody asked to watch (measured: multiple MB
         per section, e.g. the 5.5MB mobile hero). The source now attaches in the play-button click handler
         (force=true). Zero visual change — poster + icon render exactly as before. */
      if (!autoplay && !force) return;

      /* v33 settle gate: autoplay videos keep their motion, but the network attach waits for cwVideoGate
         (first interaction / `load`+2s / 8s failsafe) so segments never contend with the LCP fetch.
         The hero uses the FAST variant (motion at `load`). A user click (force) attaches immediately. */
      if (force) { cwAttachVideo(true); return; }
      if (video.__cwGatePending) return;                 // one queued attach per video
      video.__cwGatePending = true;
      window.cwVideoGate({ fast: cwIsHero }).then(() => {
        video.__cwGatePending = false;
        if (isVideoLoaded && video.getAttribute('data-loaded-src') === getSrc()) { if (shouldAutoplay()) safePlay(); return; }
        if (isOutOfView(wrapper)) return;                // scrolled away while gated; the IO re-calls on return
        cwAttachVideo(false);
      });
    }

    //loadVideo();

    function isVisible(entry, wrap) {
      const rect = entry.boundingClientRect;
      const intersection = entry.intersectionRect;
      const visibleRatio = intersection.width / rect.width;
      return visibleRatio >= thresholdValue && entry.isIntersecting;
    }

    function isOutOfView(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.bottom < 0 ||
        rect.top > window.innerHeight ||
        rect.right < 0 ||
        rect.left > window.innerWidth
      );
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const wrap = entry.target.closest('.banner_video_wrapper');
        if (!wrap) return;
        const shouldPlay = isVisible(entry, wrap) && !isOutOfView(wrap);
        if (shouldPlay) {
          if (__cwUnloadTimer) { clearTimeout(__cwUnloadTimer); __cwUnloadTimer = null; }
          loadVideo();
        } else {
          pauseVideo();
          if (isOutOfView(wrap)) { // CW fix: fully off-screen → free the decoder (debounced; reloads on return)
            if (__cwUnloadTimer) clearTimeout(__cwUnloadTimer);
            __cwUnloadTimer = setTimeout(() => { __cwUnloadTimer = null; unloadVideo(); }, 400);
          }
        }
      });
    }, {
      threshold: Array.from({ length: 21 }, (_, i) => i / 20),
    });

    observer.observe(video);

    // Controls
    playBtn?.addEventListener('click', () => {
      if (video.paused) {
        if (window.cwBankGesture) window.cwBankGesture(video); // v34: bank the tap for the deferred play() (WebKit/iOS)
        offsoundAllVideos('trigger');
        if (!isVideoLoaded) {
          loadVideo(true);   // v33 attach-on-intent: first click attaches the source, then plays on canplay
        } else {
          safePlay();
        }
        video.muted = false;
        if (muteBtn) {
          muteBtn.classList.remove('muted');
        }
      } else {
        if (muteBtn) {
          muteBtn.classList.add('muted');
        }
        pauseVideo();
      }
    });

    if (muteBtn) {
      muteBtn.style.display = showMute ? 'block' : 'none';
      muteBtn.classList.toggle('muted', video.muted);
      muteBtn.addEventListener('click', () => {
        video.muted = !video.muted;
        muteBtn.classList.toggle('muted', video.muted);
      });
    }

    if (fullscreenBtn) {
      fullscreenBtn.style.display = showFullscreen ? 'block' : 'none';
      fullscreenBtn.addEventListener('click', () => {
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
        } else if (video.webkitRequestFullscreen) {
          video.webkitRequestFullscreen();
        }
      });
    }
  });
}

function initCustomVideoPlayerWithHLS_upsell(sectionId) {
  let thresholdValue = 0.2;
  setTimeout(() => {
    thresholdValue = 0.5;
  }, 7000);

  const section = document.querySelector(`[data-section-id="${sectionId}"]`);
  if (!section) return;

  const videoWrappers = section.querySelectorAll('.banner_video_wrapper');
  const isMobile = window.innerWidth <= 767;

  videoWrappers.forEach((wrapper) => {
    const video = wrapper.querySelector('video');
    if (!video || video.dataset.initialized === 'true') return;
    video.dataset.initialized = 'true';

    const getSrc = () => isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
    const getPoster = () => isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
    const shouldAutoplay = () => (isMobile ? video.dataset.autoplayM : video.dataset.autoplay) === 'true';
    const showMute = (isMobile ? video.dataset.muteM : video.dataset.mute) === 'true';
    const showFullscreen = (isMobile ? video.dataset.fullscreenM : video.dataset.fullscreen) === 'true';

    const playBtn = wrapper.querySelector('.glb_play');
    const muteBtn = wrapper.querySelector('.glb_mute');
    const fullscreenBtn = wrapper.querySelector('.glb_fullscreen');

    let hls = null;
    let isNativeHLS = false;
    let isVideoLoaded = false;

    // Poster layer
    const posterUrl = getPoster();
    const posterWrapper = document.createElement('picture');
    posterWrapper.className = 'custom-poster-wrapper';
    Object.assign(posterWrapper.style, {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 1,
      background: `url('${posterUrl}') center center / cover no-repeat`,
      pointerEvents: 'none',
      transition: 'opacity 0.4s ease',
      opacity: 1
    });

    wrapper.style.position = 'relative';
    wrapper.appendChild(posterWrapper);
    video._posterWrapper = posterWrapper;

    // Setup video
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('preload', 'metadata');
    video.setAttribute('muted', '');
    video.muted = true;

    function safePlay() {
      const $slide = $(video).closest('.slick-slide');
      if (!$slide.hasClass('slick-current')) return;
     const playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise
          .then(() => {
            playBtn?.classList.add('playing');
            // Don't hide poster yet — wait for "playing" event
          })
          .catch((err) => {
            /* v34: the deferred play can outlive the gesture token (iOS) — retry muted rather than dying;
               the mute button (flagged muted) is the user's unmute affordance. */
            if (err && err.name === 'NotAllowedError' && !video.muted) {
              video.muted = true;
              if (muteBtn) muteBtn.classList.add('muted');
              video.play().catch(() => {
                playBtn?.classList.remove('playing');
                if (posterWrapper) posterWrapper.style.opacity = 1;
              });
              return;
            }
            playBtn?.classList.remove('playing');
            if (posterWrapper) posterWrapper.style.opacity = 1;
          });
      }
    }

    video.addEventListener('playing', () => {
      // Hide poster only when video is actually rendering
      if (posterWrapper) posterWrapper.style.opacity = 0;
      /* v34: 'playing' can fire with frame decoding stuck (iOS) — verify frames advance, nudge with a
         micro-seek, and restore the poster + paused state if rendering never starts (re-click retries). */
      if (window.cwWakeAndVerify) window.cwWakeAndVerify(video, () => {
        playBtn?.classList.remove('playing');
        if (posterWrapper) posterWrapper.style.opacity = 1;
      });
    });


    function pauseVideo() {
      video.pause();
      playBtn?.classList.remove('playing');
      if (posterWrapper) posterWrapper.style.opacity = 1;
    }

    // CW fix: fully release the decoder when the video is off-screen (prevents decoder exhaustion → random blanks).
    let __cwUnloadTimer = null;
    function unloadVideo() {
      if (hls) { try { hls.destroy(); } catch (e) {} hls = null; }
      video.hlsInstance = null;
      video.removeAttribute('src');
      video.querySelectorAll('source').forEach((s) => s.remove());
      try { video.load(); } catch (e) {}
      isVideoLoaded = false;
      video.removeAttribute('data-loaded-src');
      playBtn?.classList.remove('playing');
      if (posterWrapper) posterWrapper.style.opacity = 1;
    }

    function loadVideo() {
      const src = getSrc();
      const autoplay = shouldAutoplay();

      if (isVideoLoaded && video.getAttribute('data-loaded-src') === src) {
        if (autoplay) safePlay();
        return;
      }

      /* v33: the upsell attach waits for the settle gate too. The cart/upsell only shows after a user
         interaction, so the gate is normally already resolved and this is a no-op wait — belt & braces
         against the upsell slider ever rendering inside the load window. */
      if (video.__cwGatePending) return;                 // one queued attach per video
      video.__cwGatePending = true;
      window.cwVideoGate().then(() => {
      video.__cwGatePending = false;
      if (isVideoLoaded && video.getAttribute('data-loaded-src') === src) { if (autoplay) safePlay(); return; }
      if (isOutOfView(wrapper)) return;                  // scrolled away while gated; the IO re-calls on return

      video.setAttribute('data-loaded-src', src);
      if (src.endsWith('.m3u8')) {
        window.cwEnsureHls().then(function () {
        isNativeHLS = !(window.Hls && Hls.isSupported()) && video.canPlayType('application/vnd.apple.mpegurl') !== '';
        if (isNativeHLS) {
          video.src = src;
          video.load();
          isVideoLoaded = true;
          video.addEventListener('loadedmetadata', () => {
            if (autoplay) safePlay();
          }, { once: true });
        } else if (window.Hls && Hls.isSupported()) {
          hls = new Hls({ maxBufferLength: 3, maxMaxBufferLength: 5, capLevelToPlayerSize: true });
          cwApplyLevelCap(hls);
          hls.loadSource(src);
          hls.attachMedia(video);
          video.hlsInstance = hls;

          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            isVideoLoaded = true;
            if (autoplay) safePlay();
          });
        }
        });
      } else {
        const source = document.createElement('source');
        source.src = src;
        source.type = 'video/mp4';
        video.appendChild(source);
        video.load();
        isVideoLoaded = true;
        video.addEventListener('loadedmetadata', () => {
          if (autoplay) safePlay();
        }, { once: true });
      }

      playBtn?.classList.toggle('playing', autoplay);
      //playBtn?.style.setProperty('display', autoplay ? 'none' : 'block');
      //if (posterWrapper) posterWrapper.style.opacity = autoplay ? 0 : 1;
      });
    }

    function isVisible(entry, wrap) {
      const rect = entry.boundingClientRect;
      const intersection = entry.intersectionRect;
      const visibleRatio = intersection.width / rect.width;
      return visibleRatio >= thresholdValue && entry.isIntersecting;
    }

    function isOutOfView(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.bottom < 0 ||
        rect.top > window.innerHeight ||
        rect.right < 0 ||
        rect.left > window.innerWidth
      );
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const wrap = entry.target.closest('.banner_video_wrapper');
        if (!wrap) return;
        const shouldPlay = isVisible(entry, wrap) && !isOutOfView(wrap);
        if (shouldPlay) {
          if (__cwUnloadTimer) { clearTimeout(__cwUnloadTimer); __cwUnloadTimer = null; }
          loadVideo();
        } else {
          pauseVideo();
          if (isOutOfView(wrap)) { // CW fix: fully off-screen → free the decoder (debounced; reloads on return)
            if (__cwUnloadTimer) clearTimeout(__cwUnloadTimer);
            __cwUnloadTimer = setTimeout(() => { __cwUnloadTimer = null; unloadVideo(); }, 400);
          }
        }
      });
    }, {
      threshold: Array.from({ length: 21 }, (_, i) => i / 20),
    });

    observer.observe(video);

    // Controls
    playBtn?.addEventListener('click', () => {
      if (video.paused) {
        offsoundAllVideos('trigger');
        safePlay();
        video.muted = false;
        if (muteBtn) {
          muteBtn.classList.remove('muted');
        }
      } else {
        if (muteBtn) {
          muteBtn.classList.add('muted');
        }
        pauseVideo();
      }
    });

    if (muteBtn) {
      muteBtn.style.display = showMute ? 'block' : 'none';
      muteBtn.classList.toggle('muted', video.muted);
      muteBtn.addEventListener('click', () => {
        if (muteBtn.classList.contains('muted')) {
          const videoWrappers = document.querySelectorAll('#CartRecommendationsSlider .banner_video_wrapper, .upsell_main_slider_wrapper .banner_video_wrapper');
          videoWrappers.forEach((wrapper) => {
            let video_other = wrapper.querySelector('video');
            let muteBtn_other = wrapper.querySelector('.glb_mute');
            video_other.muted = true;
            muteBtn_other.classList.add('muted');
          })
        }
        video.muted = !video.muted;
        muteBtn.classList.toggle('muted', video.muted);

        
      });
    }

    if (fullscreenBtn) {
      fullscreenBtn.style.display = showFullscreen ? 'block' : 'none';
      fullscreenBtn.addEventListener('click', () => {
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
        } else if (video.webkitRequestFullscreen) {
          video.webkitRequestFullscreen();
        }
      });
    }
  });
}








// Initial load for all videos
function initHeroVideo() {
  document.querySelectorAll('.video-parent-section[data-section-id]').forEach((section) => {
    const id = section.getAttribute('data-section-id');
    if (id) {
      const video = section.querySelector('video');
      if (video && video.dataset.initialized === 'true') {
        // Reset to allow re-init
        delete video.dataset.initialized;
        // Optional: You can also remove the old video element
        const newVideo = video.cloneNode(true);
        video.replaceWith(newVideo);
      }
      initCustomVideoPlayerWithHLS(id);
    }
  });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initHeroVideo);

// Shopify live preview
document.addEventListener('shopify:section:load', (e) => {
  const sectionId = e.detail.sectionId;
  initCustomVideoPlayerWithHLS(sectionId);
});

// Handle resize between devices (mobile <-> desktop)
let currentDevice = window.innerWidth < 768 ? 'mobile' : 'desktop';
window.addEventListener('resize', () => {
  const newDevice = window.innerWidth < 768 ? 'mobile' : 'desktop';
  if (newDevice !== currentDevice) {
    currentDevice = newDevice;
    // Reset dataset.initialized to force re-init
    document.querySelectorAll('video').forEach((v) => {
      v.dataset.initialized = 'false';
    });

    initHeroVideo(); // Re-initialize with new device layout
  }
});


function removeCartItem(itemKey) {
  if (!itemKey) {
    console.error('Cart item key is required');
    return Promise.reject(new Error('Cart item key is required'));
  }

  // Use theme's cart.changeItem with quantity 0 to remove item
  return theme.cart.changeItem(itemKey, 0)
    .then((cartResponse) => {
      // Parse the cart response
      const cart = typeof cartResponse === 'string' ? JSON.parse(cartResponse) : cartResponse;
      
      // Rebuild the cart drawer if it exists
      if (window.theme && window.theme.cartDrawerInstance && window.theme.cartDrawerInstance.cartForm) {
        window.theme.cartDrawerInstance.cartForm.buildCart();
      } else {
        // Fallback: dispatch cart build event
        document.dispatchEvent(new CustomEvent('cart:build'));
      }
      
      // Dispatch cart updated event
      document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: {
          cart: cart,
          context: null
        }
      }));
      
      return cart;
    })
    .catch((error) => {
      console.error('Error removing cart item:', error);
      throw error;
    });
}

function removeCartItemByElement(removeBtn) {
  if (!removeBtn) {
    return Promise.reject(new Error('Remove button not found'));
  }

  const cartItem = removeBtn.closest('[data-key]');
  const qtyInput = removeBtn.closest('.cart__item')?.querySelector('[data-id]');
  const itemKey = removeBtn.getAttribute('data-key') || cartItem?.getAttribute('data-key') || qtyInput?.getAttribute('data-id');

  if (!itemKey) {
    console.error('Unable to resolve cart item key from remove button', removeBtn);
    return Promise.reject(new Error('Cart item key could not be resolved'));
  }

  return removeCartItem(itemKey);
}

document.addEventListener('click', function(event) {
  const removeBtn = event.target.closest('.removeCartItem');
  if (!removeBtn) return;

  event.preventDefault();
  event.stopPropagation();

  const itemKey = removeBtn.getAttribute('data-key');
  removeBtn.classList.add('is-loading');

  const removalPromise = itemKey
    ? removeCartItem(itemKey)
    : removeCartItemByElement(removeBtn);

  removalPromise.finally(() => {
    removeBtn.classList.remove('is-loading');
  });
});


let newsletterSubmitting = false;

$(document).on('click', '#NewsletterAjaxBtn', function (e) {
  e.preventDefault();
  if (newsletterSubmitting) return;

  newsletterSubmitting = true;

  const $form = $('#AjaxNewsletterForm');
  const $button = $(this);
  const $message = $form.find('.newsletter-message');

  $.ajax({
    url: $form.attr('action'),
    type: 'POST',
    data: new FormData($form[0]),
    processData: false,
    contentType: false,
    xhrFields: { withCredentials: true },
    headers: { 'Accept': 'application/json' },
    success: function () {
      $message.text('Thanks for subscribing!').removeAttr('hidden');
      $form[0].reset();
    },
    error: function (xhr) {
      if (xhr.status === 429) {
        $message
          .text('Please wait a moment before trying again.')
          .removeAttr('hidden');
      } else {
        $message
          .text('Something went wrong. Please try again.')
          .removeAttr('hidden');
      }
    },
    complete: function () {
      setTimeout(() => {
        newsletterSubmitting = false;
        $button.prop('disabled', false);
      }, 5000); // ⏱ cooldown
    }
  });

  $button.prop('disabled', true);
});


(function() {
  'use strict';
  
  // Handle scroll to product info
  function initScrollToInfo() {
    const scrollButtons = document.querySelectorAll('.scroll-to-product-info');
    
    scrollButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const targetSelector = this.getAttribute('data-scroll-target') || '.single_pdp_summary';
        const targetElement = document.querySelector(targetSelector);
        
        if (targetElement) {
          const header = document.querySelector('.site-header') || document.querySelector('header');
          const headerHeight = header ? header.offsetHeight : 0;
          const targetPosition = targetElement.offsetTop - headerHeight - 20;
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollToInfo);
  } else {
    initScrollToInfo();
  }
  
  // Re-initialize on section load (for theme editor)
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initScrollToInfo);
  }
})();


document.addEventListener('DOMContentLoaded', function () {
  // Suffix match (template-ID-agnostic): the template-- numeric prefix is assigned
  // per-theme on upload, so the original hardcoded id only matched the source theme.
  const section1 = document.querySelector(
    '[id$="__custom_featured_products_FgkV8w"]'
  );

  const section2 = document.querySelector(
    '[id$="__home_media_slider_qHX43L"]'
  );

  if (section1 && section2) {
    const wrapper = document.createElement('div');
    wrapper.className = 'switch_section_ordering';

    // Insert wrapper before first section
    section1.parentNode.insertBefore(wrapper, section1);

    // Move both sections inside wrapper
    wrapper.appendChild(section1);
    wrapper.appendChild(section2);
  }
});

(function () {
  // CW perf-fix 2026-06-26: removed debug console.log spam. The 'ANY click' log ran on EVERY
  // document click (capture-phase) — avoidable per-tap main-thread/INP cost on mobile.
  var MOBILE_MAX_WIDTH = 768;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.klaviyotrigger');
    if (!btn) {
      return;
    }

    e.preventDefault();

    var isMobile = window.matchMedia('(max-width: ' + MOBILE_MAX_WIDTH + 'px)').matches;
    var formId = isMobile ? 'XcWMTF' : 'TYviBq';

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);

  }, true);
})();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-mascara-tyrant-edition .product-single__title').forEach(function (el) {
    el.innerHTML = el.innerHTML.replace(/(mascara)(\s+)/i, '$1<br>');
  });
});

const viewport = document.querySelector('meta[name="viewport"]');
const content = viewport.getAttribute('content');

document.addEventListener('focusin', (e) => {
  if (e.target.matches('input, select, textarea')) {
    viewport.setAttribute('content', content + ', maximum-scale=1');
  }
});

document.addEventListener('focusout', (e) => {
  if (e.target.matches('input, select, textarea')) {
    viewport.setAttribute('content', content); // restore pinch-zoom
  }
});

// Defer mega-menu/drawer bestseller videos: attach an HLS-aware source only when the video becomes
// visible (menu/drawer opened). data-video-src is a merchant "Video URL" that may be an HLS .m3u8
// (Bunny) — Chrome/Firefox/Android need hls.js; only Safari plays HLS from a plain <video src>.
// Mirrors the theme's loadVideoSource() pattern (custom.js ~187) instead of assigning src directly.
(function () {
  var vids = document.querySelectorAll('video.megamenu__video-el[data-video-src]');
  if (!vids.length) return;

  function attachVideo(v) {
    var src = v.dataset.videoSrc;
    if (!src || v.src || v.hlsInstance) return;
    v.preload = 'metadata';
    if (src.endsWith('.m3u8')) {
      window.cwEnsureHls().then(function () {
      if (!(window.Hls && Hls.isSupported()) && v.canPlayType('application/vnd.apple.mpegurl')) {
        v.src = src;                                       // Safari / iOS (no MSE) — native HLS fallback
      } else if (window.Hls && Hls.isSupported()) {        // Chrome / Firefox / Edge / Android — hls.js (preferred)
        var hls = new Hls({ maxBufferLength: 3, maxMaxBufferLength: 5, capLevelToPlayerSize: true });
        cwApplyLevelCap(hls);
        hls.loadSource(src);
        hls.attachMedia(v);
        v.hlsInstance = hls;
        hls.on(Hls.Events.ERROR, function (_, d) {         // fatal → revert to poster, never a black frame
          if (d && d.fatal) {
            try { hls.destroy(); } catch (e) {}
            v.hlsInstance = null;
            var wrap = v.closest('.megamenu__bestseller-video-wrapper');
            if (wrap) { wrap.classList.remove('show-video'); wrap.classList.add('show-poster'); }
          }
        });
      }
      });
    } else {
      v.src = src;                                         // MP4 / non-HLS unchanged
    }
  }

  if (!('IntersectionObserver' in window)) {
    vids.forEach(attachVideo);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) {
        attachVideo(en.target);
        io.unobserve(en.target);
      }
    });
  });

  vids.forEach(function (v) { io.observe(v); });
})();